export function transformUserToApiUser(user) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return {
        anonymized_at: (_a = user.anonymized_at) !== null && _a !== void 0 ? _a : null,
        avatar_url: (_b = user.avatar_url) !== null && _b !== void 0 ? _b : null,
        company_id: (_c = user.company_id) !== null && _c !== void 0 ? _c : null,
        default_outbound_number: (_d = user.default_outbound_number) !== null && _d !== void 0 ? _d : null,
        email: (_e = user.email) !== null && _e !== void 0 ? _e : null,
        family_name: (_f = user.family_name) !== null && _f !== void 0 ? _f : null,
        given_name: (_g = user.given_name) !== null && _g !== void 0 ? _g : null,
        has_scim_enabled: !!user.has_scim_enabled,
        id: user.id,
        is_admin: !!user.is_admin,
        is_agent: !!user.is_agent,
        name: (_h = user.name) !== null && _h !== void 0 ? _h : null,
        org_id: (_j = user.org_id) !== null && _j !== void 0 ? _j : null,
        phone_number: (_k = user.phone_number) !== null && _k !== void 0 ? _k : null,
        roles: (_l = user.roles) !== null && _l !== void 0 ? _l : ['enduser'],
        skills: (_m = user.skills) !== null && _m !== void 0 ? _m : null,
        is_banned_hack: (_o = user.is_banned_hack) !== null && _o !== void 0 ? _o : null,
        external_id: (_p = user.external_id) !== null && _p !== void 0 ? _p : null,
    };
}
